import { SpecificChartFunctionality } from '../../constants/common'

export enum DrawingTool {
  Arrow = 'arrow',
  Brush = 'brush',
  Callout = 'callout',
  Curve = 'curve',
  ElliottWaves = 'elliott-wave',
  Ellipse = 'ellipse',
  FibonacciRetracements = 'fibonacci-retracements',
  HorizontalLine = 'horizontal-line',
  Measure = 'measure',
  Mouse = 'mouse',
  Pitchfork = 'pitchfork',
  Polygon = 'polygon',
  Position = 'position',
  Rectangle = 'rectangle',
  RotatedRectangle = 'rotated-rectangle',
  ScaledLine = 'scaled-line',
  ScaledText = 'scaled-text',
  Triangle = 'triangle',
  VerticalLine = 'vertical-line',
  Xabcd = 'xabcd',
}

export enum DrawingActions {
  DeleteDrawings = 'delete-drawings',
}

export enum DrawingSetting {
  PreserveDrawings = 'preserve-drawings',
  DrawingModeContinuous = 'drawing-mode-continuous',
  HideDrawings = 'hide-drawings',
  LockDrawings = 'lock-drawings',
}

export interface IToolBarProps {
  isSidebar?: boolean
  isHorizontal?: boolean
  /**
   * Current selected tool id
   */
  activeTool: DrawingTool
  /**
   * On tool item select callback
   */
  onActiveToolChange: (activeTool: DrawingTool) => void
  /**
   * On drawing actions item select callback
   */
  onDrawingActionClick?: (actionId: DrawingActions) => void
  /**
   * On drawing settings item select callback
   */
  onDrawingSettingClick?: (settingId: DrawingSetting) => void
  /**
   * Current state of drawing settings
   */
  drawingSettings: Record<DrawingSetting, boolean>
  /**
   * Add preserve drawing settings button to toolbar
   * only available on interactive charts
   */
  isPreserveDrawingsAvailable?: boolean
  isAlternativeTheme?: boolean
  /**
   * Are tools disabled
   */
  areToolsDisabled?: boolean
  isIdea: boolean
  specificChartFunctionality: SpecificChartFunctionality
}

export interface IToolbarItemProperties {
  title: string
  icon: string
  iconActive?: string
  titleActive?: string
}

export interface IToolbarDrawingTool extends IToolbarItemProperties {
  id: DrawingTool
}

export interface IToolbarDrawingAction extends IToolbarItemProperties {
  id: DrawingActions
}

export interface IToolbarDrawingSetting extends IToolbarItemProperties {
  id: DrawingSetting
}

export interface IToolbarItem {
  toolGroupTitle?: string
}

export interface IToolbarDrawingToolItem extends IToolbarItem {
  defaultItem: IToolbarDrawingTool
  toolGroup?: Array<IToolbarDrawingTool>
}

export interface IToolbarDrawingActionItem extends IToolbarItem {
  defaultItem: IToolbarDrawingAction
  toolGroup?: Array<IToolbarDrawingAction>
}

export interface IToolbarDrawingsSettingItem extends IToolbarItem {
  defaultItem: IToolbarDrawingSetting
  toolGroup?: Array<IToolbarDrawingSetting>
  isDisabled?: boolean
  disabledTooltip?: string
}
